/* eslint-disable @typescript-eslint/no-unused-expressions */
import Prism from "prismjs";
import "prismjs/components/prism-excel-formula";

Prism.languages["excel-formula"] = Prism.languages.extend("excel-formula", {});
